<template>
  <mounting-portal mount-to="#vue-popups" append slim>
    <transition name="fade">
      <div
        v-scroll-lock="show && blockPageScroll"
        class="yt-popup-slide__container u-fixed-full"
        @click.self="close"
        v-if="show"
      ></div>
    </transition>
    <div class="yt-popup-slide"  :class="{'visible': show}">
      <div class="yt-popup-slide__header">
        <div class="yt-popup-slide__title" v-html="title"></div>
        <div
          class="yt-popup-slide__close"
          @click.self="close"
          v-if="showCloseButton"
        >
          <Icon
            icon="close"
            color="#9999A9"
          />
        </div>
      </div>
      <div class="yt-popup-slide__body">
        <slot/>
      </div>
    </div>
  </mounting-portal>
</template>

<script>
import Icon from "@/components/icons/index.vue";
export default {
  name: "yt-popup-slide",
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    blockPageScroll: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    close(){
      this.$emit("close", true);
    }
  }
}
</script>

<style lang="scss" scoped>
.yt-popup-slide{
  position: fixed;
  bottom: -100%;
  z-index: 999999;
  background: var.$white;
  padding: 16px 16px 32px 16px;
  border-radius: 24px 24px 0 0;
  width: 100%;
  left: 0;
  transition: bottom .2s;

  &.visible {
    bottom: 0;
  }

  &__container{

    background-color: rgba(var.$black, 0.4);
    z-index: 99999;
  }
  &__close{
    width: 45px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: -12px;
    top: 0;
  }
  &__header{
    height: fit-content;
    position: relative;
    margin-bottom: 20px;
  }
  &__title{
    font-size:19px;
    color: var.$black;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }
}
</style>
